import React from "react";
import logo from "../../images/logo-games.webp";
import { Container, Col, Row } from "react-bootstrap";
import {
  IoChatboxEllipsesOutline,
  IoMapOutline,
  IoTimeOutline,
  IoCardOutline,
  IoLogoFacebook,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoTwitter,
} from "react-icons/io5";
export default function Footer() {
  return (
    <>
      <div className="footer-1 pt-5 pb-5 mt-5">
        <Container fluid>
          <Row>
            <Col md={3}>
              <div className="footer-option">
                <IoChatboxEllipsesOutline />
                <h4>We HAVE A CHAT</h4>
                <p>+91 8562087096, +91 7976958629</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="footer-option">
                <IoMapOutline />
                <h4>OUR LOCATION</h4>
                <p>181 Arple Rd E, St Albans Swites 3021, USA</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="footer-option">
                <IoTimeOutline />
                <h4>TIME WORK</h4>
                <p>5 Days a week from 08 AM to 8 PM</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="footer-option">
                <IoCardOutline />
                <h4>100% SECURE</h4>
                <p>Faster & More Secure Online Gaming Payments</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <footer className="secondary-footer pt-5 pb-5">
        <Container fluid>
          <Row>
            <Col md={3}>
              <div className="footer-box">
                <img src={logo} className="img-fluid" alt="" />
                <ul>
                  <li>Phone: +01 234 567 89</li>
                  <li>
                    E-mail:{" "}
                    <span>Foxshop@gmail.com</span>
                  </li>
                  <li>Hours: 10:00 - 18:00, Mon - Fri</li>
                  <li>
                    <span>Video Presentation</span>
                  </li>
                  <li>
                    <span className="link-special">
                      Online Support
                    </span>
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={3}>
              <div className="footer-box">
                <h4>INFORMATION</h4>
                <ul>
                  <li>
                    <span>About</span>
                  </li>
                  <li>
                    <span>Service </span>
                  </li>
                  <li>
                    <span>Shop</span>
                  </li>
                  <li>
                    <span>Terms of Service</span>
                  </li>
                  <li>
                    <span>Conrtact us</span>
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={3}>
              <div className="footer-box">
                <h4>OUR SOCIALS</h4>
                <ul className="socail-icons">
                  <li>
                    <span>
                      <IoLogoFacebook />
                    </span>
                  </li>
                  <li>
                    <span>
                      <IoLogoTwitter />{" "}
                    </span>
                  </li>
                  <li>
                    <span>
                      <IoLogoLinkedin />
                    </span>
                  </li>
                  <li>
                    <span>
                      <IoLogoInstagram />
                    </span>
                  </li>
                </ul>
              </div>
            </Col>

            <Col md={3}>
              <div className="footer-box">
                <h4>ABOUT US</h4>
                <p>
                  Store - worldwide fashion store since 2015. We sell over 5000+
                  branded prod
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>

      <div className="copyright">
        <p>All Theme Reserved Under Madehuge Infosolution Pvt. Ltd. All rights reserved.</p>
      </div>
    </>
  );
}
